import {Typography} from "@mui/material";
import {
    DaGridContainer,
    DaGridLoadingOverlay,
    DaGridSettings,
    MuiGridDataProp,
    muiGridFilterIsValid,
    MuiGridStateProp
} from "../_shared";
import {
    DataGrid,
    GridColDef,
    GridLinkOperator,
    GridColumnVisibilityModel,
    GridFilterModel, GridSortModel
} from "@mui/x-data-grid";
import {SystemStyleObject} from "@mui/system";

export const HomeViewGrid = (
    {
        title = "",
        gridColumns = [],
        gridRowIdColumn = "id",
        gridState = {
            page: 0,
            page_size: DaGridSettings.defaultPageSize,
            filters: {
                items: [],
                linkOperator: GridLinkOperator.Or
            },
            sorts: [],
        },
        setGridState,
        gridData = {rows: [], row_count: 0},
        isGridLoading = true,
        columnVisibility = {},
        containerStyle = { height: 300, width: '100%',}
    } : {
        title: string,
        gridColumns: GridColDef[],
        gridRowIdColumn: string,
        gridState: MuiGridStateProp,
        setGridState: (state: MuiGridStateProp) => void,
        gridData: MuiGridDataProp,
        isGridLoading: boolean,
        columnVisibility: GridColumnVisibilityModel,
        containerStyle: SystemStyleObject,
    }
): JSX.Element => {

    const onGridPageChange = (page: number) => {
        setGridState({
            ...gridState,
            page: page
        });
    };

    const onGridPageSizeChange = (size: number) => {
        setGridState({
            ...gridState,
            page_size: size
        });
    };

    const onGridFilterChange = (model: GridFilterModel) => {
        if(muiGridFilterIsValid(model)) {
            setGridState({
                ...gridState,
                filters: model
            });
        }
    };

    const onGridSortChange = (model: GridSortModel) => {
        setGridState({
            ...gridState,
            sorts: model
        });
    };

    return (
        <>
            <Typography variant="h5">
                {title}
            </Typography>
            <DaGridContainer
                sx={containerStyle}
            >
                <DataGrid
                    components={{
                        LoadingOverlay: DaGridLoadingOverlay,
                    }}
                    loading={isGridLoading}
                    rows={gridData.rows}
                    columns={gridColumns}
                    getRowId={(row) => row[gridRowIdColumn]}
                    rowCount={gridData.row_count}
                    filterMode="server"
                    paginationMode="server"
                    sortingMode="server"
                    onFilterModelChange={onGridFilterChange}
                    onSortModelChange={onGridSortChange}
                    pagination
                    page={gridState.page}
                    pageSize={gridState.page_size}
                    onPageChange={onGridPageChange}
                    onPageSizeChange={onGridPageSizeChange}
                    rowsPerPageOptions={DaGridSettings.rowsPerPageOptions}
                    headerHeight={DaGridSettings.headerRowHeight}
                    rowHeight={DaGridSettings.rowHeight}
                    // checkboxSelection
                    disableSelectionOnClick
                    columnVisibilityModel={columnVisibility}
                />
            </DaGridContainer>
        </>
    )
}